import { ApiService } from '@core/services/api/api.service';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetAlternateTextDTO } from '@models/alternate-text';

@Injectable({ providedIn: 'root' })
export class AlternateTextService {
  private url = `${environment.apiRoute}/blocks`;
  constructor(private apiService: ApiService) {}
  getAlternateText(blockId: number, language: string) {
    return this.apiService.get<GetAlternateTextDTO>(
      `${this.url}/${blockId}/alternate-texts/${language}`,
    );
  }
}
